export default "__VITE_ASSET__DcKPAAk5__"